
import { useState, useEffect } from "react";
import axiosPublic from "../store/api/axiosPublic";

export default function useBeforeLoginApi() {
  const [allLeads, setAllLeads] = useState([]);
  const [pagination, setPagination] = useState({});
  const [cartLeads, setCartLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  


  /* ---------------- GUEST CART (LOCAL STORAGE) ---------------- */
  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("guestCart") || "[]");
    setCartLeads(storedCart);
  }, []);

  const syncGuestCart = (cart) => {
    localStorage.setItem("guestCart", JSON.stringify(cart));
  };

  const addLeadToCart = (lead) => {
    setCartLeads((prev) => {
      if (prev.some((l) => l.id === lead.id)) return prev;

      const updated = [...prev, lead];
      syncGuestCart(updated);

      // Update UI: mark this lead as checked
      setAllLeads((prevLeads) =>
        prevLeads.map((l) => (l.id === lead.id ? { ...l, isChecked: true } : l))
      );

      return updated;
    });
  };

  const removeLeadFromCart = (leadId) => {
    setCartLeads((prev) => {
      const updated = prev.filter((l) => l.id !== leadId);
      syncGuestCart(updated);

      // Update UI: mark this lead as unchecked
      setAllLeads((prevLeads) =>
        prevLeads.map((l) => (l.id === leadId ? { ...l, isChecked: false } : l))
      );

      return updated;
    });
  };

  /* ---------------- LEADS ---------------- */
  const fetchAllLeads = async (page = 1,params = {}) => {
    setLoading(true);
    try {
      const res = await axiosPublic.get(
        "admin/all-leads",
        {
          params: {
            page,
            limit: 10,
            ...params,
          },
        }
      );

      const fetchedLeads = res?.data?.data || [];

      // Mark leads as checked if they are in cart
      const syncedLeads = fetchedLeads.map((lead) => ({
        ...lead,
        isChecked: cartLeads.some((l) => l.id === lead.id),
      }));

      setAllLeads(syncedLeads);
      setPagination(res?.data?.pagination || {});
    } catch (err) {
      console.error("Fetch leads failed", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllLeads(1);
  }, [cartLeads]); // re-sync allLeads whenever cart changes

  return {
    allLeads,
    pagination,
    cartLeads,
    loading,
    fetchAllLeads,
    addLeadToCart,
    removeLeadFromCart,
  };
}
